//NoSecretsChronicles.jsx 
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';


const NoSecretsChronicles = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [tasks, setTasks] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [name, setName] = useState('');
  const [place, setPlace] = useState('');
  const [tags, setTags] = useState('');
  const [purpose, setPurpose] = useState('');
  const [purposeHead, setPurposeHead] = useState('');
  const purposeInitialized = useRef(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);

  const fetchTasks = useCallback(() => {
    const config = {
      url: "/tasks/nosecret",
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: authState.user._id}
    };
    // console.log("My Task Search Payload: ", config);
    fetchData(config, { showSuccessToast: false }).then(data => setTasks(data.tasks));
  }, [authState.token, fetchData, authState.user._id]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchTasks(purpose);
  }, [authState.isLoggedIn, fetchTasks, purpose]);


  const handleView = (taskId) => {
    setSelectedTaskId(prevId => (prevId === taskId ? null : taskId));
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedTasks = [...tasks].sort((a, b) => new Date(b.taskDate) - new Date(a.taskDate));

  return (
    <>
      <MainLayout>
        <div className='mt-12'>
          <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Nothing Secrets</h3>
        </div>
          <div className="my-2 mx-auto max-w-[700px] py-4">
            <div className="border border-gray-300 p-4 mt-4">
              <div className="mt-2">
                <div className="mt-2">
                  {tasks && tasks.length !== 0 && (
                    <div className="flex justify-between items-center border-b border-b-gray-300">
                      <div>
                      <h3 className='text-m mt-1 mx-1 text-yellow-200'>{tasks.length} Records Found!</h3>
                      </div>
                  </div>
                  )}
                </div>
              </div>
              {loading ? (
                <Loader />
              ) : (
                <div>
                  {tasks && tasks.length === 0 ? (
                    <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                      <div className="flex justify-between items-center">
                      <div>
                      <h3 className='text-lg mt-1 mx-2 text-orange-400'>No Record Found!</h3>
                      </div>
                  </div>
                    </div>
                  ) : (
                    sortedTasks.map((task, index) => (
                      <div key={task._id} className='bg-white my-1 p-1 text-gray-600 rounded-md shadow-md text-sm'>
                        <div className='flex'>
                          <span className='font-medium'>{index + 1}{'. '}{task.title}{', '}({formatDateTime(task.taskDate)})</span>
                          <Tooltip text={"View details"} position={"top"}>
                            <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(task._id)}>
                              <i className="fa-solid fa-eye"></i>
                            </span>
                          </Tooltip>
                        </div>
                        {selectedTaskId === task._id && (
                          <div className='bg-gray-200 text-black'>
                            <p className='bg-blue-700 text-white justify-center text-m mt-2 mb-2'>
                              <h2 className='text-white'><strong>{task.purpose.charAt(0).toUpperCase() + task.purpose.slice(1)} Details</strong></h2>
                            </p>
                            <p className='text-yellow-600'><strong >Code:</strong> {task.taskCode}</p>
                            <p><strong>Purpose:</strong> {task.purpose}</p>
                            <p><strong>Title:</strong> {task.title}</p>
                            <p><strong>Description:</strong> {task.description}</p>
                            <p><strong>Name:</strong> {task.name}</p>
                            <p><strong>Place:</strong> {task.place}</p>
                            <p><strong>Amount:</strong> {task.currency} {task.amount}</p>  
                            <p><strong>Date:</strong> {formatDateTime(task.taskDate)}</p>
                            <p><strong>Secret Key:</strong> {task.secretKey}</p>
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
      </MainLayout>
    </>
  )
}

export default NoSecretsChronicles;
